import React from 'react';
import { Col, Row, Card, Typography, Button, ButtonGroup, Tag, Space, Popover } from '@douyinfe/semi-ui';
import { projects } from './data/projects';
import { isEmpty, isNull } from 'lodash';
import { FaKickstarter, FaExternalLinkAlt, FaDonate, FaTelegram, FaInfoCircle, FaRedditAlien } from "react-icons/fa";
import { FaSquareXTwitter, FaYoutube } from "react-icons/fa6";

import ModalDetails from './common/ModalDetails';
import ModalConfirm from './common/ModalConfirm';

class ProjectsPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            details_modal: false,
            details_data: null,
            details_name: null,
            confirm_modal: false,
            confirm_caption: null,
            confirm_text: null,
            confirm_href: null
        }
    }

    render() {

        const modal_opened = this.state.details_modal;
        const confirm_modal = this.state.confirm_modal;

        return (
            <div className="grid-container">
                <div className="page-header">
                    <Typography.Text className="page-title">Projects</Typography.Text>
                </div>

                <Row 
                    type="flex" 
                    justify="center" 
                    gutter={[4, 4]} 
                    className="card-row"
                >
                    { !isEmpty(projects) ?
                        projects.map((item) => {
                            return (
                                <Col 
                                    xs={24} 
                                    sm={12} 
                                    md={12}
                                    lg={6} 
                                    key={item.id}
                                    className="card-col"
                                >
                                    <div className="card-content">
                                        <Card 
                                            title={
                                                <Typography.Text className="card-title-l">
                                                    {item.project.icon}
                                                    {item.project.brand}
                                                </Typography.Text>
                                            }
                                            className="info-card"
                                            headerExtraContent={
                                                <ButtonGroup>
                                                    <Popover
                                                        showArrow
                                                        content={<span className='popover-content'>Description</span>}
                                                        position="top"
                                                        className="popover-custom"
                                                    >
                                                        <Button
                                                            icon={<FaInfoCircle size={18}/>}
                                                            theme="borderless"
                                                            className="button-social"
                                                            onClick={() => this.setState({details_data: item.project.description, details_modal: true, details_name: item.project.name})}
                                                        />
                                                    </Popover>
                                                    {item.buttons.kickstarter.enable && 
                                                        <Popover 
                                                            showArrow 
                                                            content={<span className="popover-content">Kickstarter</span>} 
                                                            position="top"
                                                            className="popover-custom"
                                                        >
                                                            <Button 
                                                                icon={<FaKickstarter size={18}/>} 
                                                                theme="borderless" 
                                                                className="button-social"
                                                                onClick={() => this.setState({confirm_modal: true, confirm_caption: 'Follow the link?', confirm_text: `Open project's Kickstarter page in the new tab?`, confirm_href: item.buttons.kickstarter.link})}
                                                            />
                                                        </Popover>
                                                    }
                                                    {item.buttons.donate.enable && 
                                                        <Popover 
                                                            showArrow 
                                                            content={<span className="popover-content">Donate</span>} 
                                                            position="top"
                                                            className="popover-custom"
                                                        >
                                                            <Button 
                                                                icon={<FaDonate size={18}/>} 
                                                                theme="borderless" 
                                                                className="button-social"
                                                                onClick={() => this.setState({confirm_modal: true, confirm_caption: 'Follow the link?', confirm_text: `Open project's donation page in the new tab?`, confirm_href: item.buttons.donate.link})}
                                                            />
                                                        </Popover>
                                                    }
                                                    {item.buttons.website.enable && 
                                                        <Popover 
                                                            showArrow 
                                                            content={<span className="popover-content">Open link</span>} 
                                                            position="top"
                                                            className="popover-custom"
                                                        >
                                                            <Button 
                                                                icon={<FaExternalLinkAlt size={18}/>} 
                                                                theme="borderless" 
                                                                className="button-social"
                                                                onClick={() => this.setState({confirm_modal: true, confirm_caption: 'Follow the link?', confirm_text: `Open project's website in the new tab?`, confirm_href: item.buttons.website.link})}
                                                            />
                                                        </Popover>
                                                    }
                                                </ButtonGroup>
                                            }
                                        >
                                            <div className="card-content-inner-projects">
                                                <Typography.Paragraph className="card-paragraph">
                                                    <strong>Title:</strong> <span className='card-info-span'>{item.project.title}</span>
                                                </Typography.Paragraph>
                                                <Typography.Paragraph className="card-paragraph">
                                                    <strong>Category:</strong> 
                                                    <Tag 
                                                        size="large" 
                                                        color='teal' 
                                                        type="solid" 
                                                        shape='circle' 
                                                        prefixIcon={item.project.category.icon}
                                                        className="tag-custom-no-border tag-teal"
                                                    >
                                                        {item.project.category.name}
                                                    </Tag>
                                                </Typography.Paragraph>
                                                <Typography.Paragraph className="card-paragraph">
                                                    <strong>Tags:</strong>
                                                    <Space wrap className="tag-custom-no-border">
                                                        {item.project.tags.map((el) => (
                                                            <Tag 
                                                                key={el.tag}
                                                                size="large" 
                                                                color='cyan' 
                                                                type="solid" 
                                                                shape='circle' 
                                                                prefixIcon={!isNull(el.icon) ? el.icon : null}
                                                                className="tag-custom-no-border tag-cyan"
                                                            >
                                                                {el.tag}
                                                            </Tag>
                                                        ))}
                                                    </Space>
                                                </Typography.Paragraph>
                                                <Typography.Paragraph className="card-paragraph">
                                                    <strong>Stage:</strong>
                                                    <Tag 
                                                        size="large" 
                                                        color='amber' 
                                                        type="solid" 
                                                        shape='circle'
                                                        className="tag-custom-no-border tag-amber"
                                                    >
                                                        {item.project.stage}
                                                    </Tag>
                                                </Typography.Paragraph>
                                                <Typography.Paragraph className="card-paragraph">
                                                    <strong>Release date:</strong>
                                                    <Tag 
                                                        size="large" 
                                                        color='blue' 
                                                        type="solid" 
                                                        shape='circle'
                                                        className="tag-custom-no-border tag-blue"
                                                    >
                                                        {item.project.release_date}
                                                    </Tag>
                                                </Typography.Paragraph>
                                                <Typography.Paragraph className="card-paragraph card-resources" style={{display: 'flex', lineHeight: '32px'}}>
                                                    <strong>Resources:</strong>
                                                    <ButtonGroup className="button-group-social">
                                                        {item.socials.youtube.enable && 
                                                            <Popover 
                                                                showArrow 
                                                                content={<span className="popover-content">Youtube channel</span>} 
                                                                position="top"
                                                                className="popover-custom"
                                                            >
                                                                <Button 
                                                                    icon={<FaYoutube size={18}/>} 
                                                                    theme="borderless" 
                                                                    className="button-social"
                                                                    onClick={() => this.setState({confirm_modal: true, confirm_caption: 'Follow the link?', confirm_text: `Open youtube channel in the new tab?`, confirm_href: item.socials.youtube.link})}
                                                                />
                                                            </Popover>
                                                        }
                                                        {item.socials.x.enable && 
                                                            <Popover 
                                                                showArrow 
                                                                content={<span className="popover-content">News on X</span>} 
                                                                position="top"
                                                                className="popover-custom"
                                                            >
                                                                <Button 
                                                                    icon={<FaSquareXTwitter size={18}/>} 
                                                                    theme="borderless" 
                                                                    className="button-social"
                                                                    onClick={() => this.setState({confirm_modal: true, confirm_caption: 'Follow the link?', confirm_text: `Open news on x.com in the new tab?`, confirm_href: item.socials.x.link})}
                                                                />
                                                            </Popover>
                                                        }
                                                        {item.socials.reddit.enable && 
                                                            <Popover 
                                                                showArrow 
                                                                content={<span className="popover-content">News on Reddit</span>} 
                                                                position="top"
                                                                className="popover-custom"
                                                            >
                                                                <Button 
                                                                    icon={<FaRedditAlien size={18}/>} 
                                                                    theme="borderless" 
                                                                    className="button-social"
                                                                    onClick={() => this.setState({confirm_modal: true, confirm_caption: 'Follow the link?', confirm_text: `Open news on reddit in the new tab?`, confirm_href: item.socials.reddit.link})}
                                                                />
                                                            </Popover>
                                                        }
                                                        {item.socials.telegram.enable && 
                                                            item.socials.telegram.links.map((btn) => (
                                                                <Popover 
                                                                    key={btn.name}
                                                                    showArrow 
                                                                    content={<span className="popover-content">{btn.name}</span>}
                                                                    position="top"
                                                                    className="popover-custom"
                                                                >
                                                                    <Button 
                                                                        icon={<FaTelegram size={18}/>} 
                                                                        theme="borderless" 
                                                                        className="button-social"
                                                                        onClick={() => this.setState({confirm_modal: true, confirm_caption: 'Follow the link?', confirm_text: `Open ${btn.name} in the new tab?`, confirm_href: btn.link})}
                                                                    />
                                                                </Popover>
                                                            ))
                                                        }
                                                    </ButtonGroup>
                                                </Typography.Paragraph>
                                            </div>
                                        </Card>
                                    </div>
                                </Col>
                            )
                        }):
                        <div className="no-data">
                            No data available
                        </div>
                    }
                </Row>
                {modal_opened && <ModalDetails open={modal_opened} onClose={() => this.setState({ details_modal: false })} project_name={this.state.details_name} details={this.state.details_data} />}
                {confirm_modal && <ModalConfirm open={confirm_modal} onClose={() => this.setState({ confirm_modal: false })} caption={this.state.confirm_caption} text={this.state.confirm_text} link={this.state.confirm_href}/>}
            </div>
        );
    }
}

export default ProjectsPage;